import { createContext, useContext, ReactNode } from "react";

type PermissionsContextType = {
  permissions: string[];
  clientPermissions: string[];
  subClientPermissions: string[];
};

const PermissionsContext = createContext<PermissionsContextType | undefined>(undefined);

export const PermissionsProvider = ({ children, permissions, subClientPermissions, clientPermissions }: { children: ReactNode; permissions: string[]; subClientPermissions: string[]; clientPermissions: string[]; }) => {

  return <PermissionsContext.Provider value={{ permissions, clientPermissions, subClientPermissions }}>{children}</PermissionsContext.Provider>;
};

export const usePermissions = () => {
  const context = useContext(PermissionsContext);
  if (!context) {
    throw new Error("usePermissions must be used within a PermissionsProvider");
  }
  return context;
};
